import CarClassicSliderContainer from "../../../components/car/detail/CarClassicSlider";

const CarClassicSlider = () => {
  return <CarClassicSliderContainer />;
};

export default CarClassicSlider;
